export const colors = {
  primary: '#20007f',
  primaryLight: '#4527a0'
} as const

export type ThemeColors = typeof colors
